import { Injectable } from "@angular/core";
import { GeneralStore } from "../store/general";
import { GeneralDetailsStore } from "../store/general-details";
import { RequestDetailsStore } from "../store/request-details";
import { AttachmentsStore } from "../store/attachments";
import { DeclarationsStore } from "../store/declarations";
import { MCResponse, MCRootStoreService, MCUtils } from "@maslul/common-services";
import { ApplicantDetailsStore } from "../store/applicant-details";
import { MIUnionRequestHttpService } from "../shared/union-request-http";
import { Observable } from "rxjs";

import { Request } from "../../models/request/request";
import { RequestService } from "../request/request";


@Injectable({ providedIn: 'root' })
export class SendService {

    constructor(
        private unionRequestHttpService: MIUnionRequestHttpService,
        private requestService: RequestService
    ) {

    }


    getSendObj(): Request {
        const requestObj: Request = {
            language: this.requestService.getLanguage(),
            formState: this.requestService.getFormState(),
            status: this.requestService.getRequestStatus(),
            attachmentsDetails: this.requestService.getAttachmentsDetails(),
            requestDetails: this.requestService.getRequestDetails(),
            generalDetails: this.requestService.getGeneralDetails(),
            declartionDetails: this.requestService.getDeclartionDetails(),
            applicantDetails: this.requestService.getApplicantDetails(),
            approvalTypes: this.requestService.getApprovalTypes(),
            products: this.requestService.getProducts()
        }
        return requestObj;
    }

    send(): Observable<MCResponse> {
        const requestData: Request = this.getSendObj();
        return this.unionRequestHttpService.send(requestData)
    }
}